import { Routes, Route } from "react-router-dom";
import { StaticRoutes } from "./pages/routes";
import Bidding from "./pages/Bidding/index";
import TripBoard from "./pages/TripBoard/index";
import Seniority from "./pages/Seniority/index";
import UPSPricing from "./pages/UPSPricing/Pricing";
import ASPricing from "./pages/ASPricing/ASPricing";
import AAPricing from "./pages/AAPricing";
import Contact from "./pages/Contact/index";
import Login from "./pages/Login/index";
import HomePage from "./pages/HomePage";
import MyAccount from "./pages/MyAccount";
import Profile from "./pages/MyAccount/Profile";
import ConfirmEmail from "./pages/ConfirmEmail/ConfirmEmail";
import PasswordResetSent from "./pages/PasswordResetSent";
import AccountManagement from "./pages/AccountManagement/AccountManagement";
import { Auth } from "./auth";
import { AccountContainer } from "./hooks/useAccount";
import { QueryClient, QueryClientProvider } from "react-query";
import ScrollToTop from "./components/ScrollToTop";
import RequireAuth from "./components/RequireAuth";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // keep data cached for 10 minutes unless invalidated earlier
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Auth.Provider>
        <AccountContainer.Provider>
          <ScrollToTop />
          <Routes>
            <Route exact path={StaticRoutes.Home} element={<HomePage />} />
            <Route path={StaticRoutes.Bidding} element={<Bidding />} />
            <Route path={StaticRoutes.TripBoard} element={<TripBoard />} />
            <Route path={StaticRoutes.Seniority} element={<Seniority />} />
            <Route path={StaticRoutes.UPSPricing} element={<UPSPricing />} />
            <Route path={StaticRoutes.ASPricing} element={<ASPricing />} />
            <Route path={StaticRoutes.AAPricing} element={<AAPricing />} />
            <Route path={StaticRoutes.Contact} element={<Contact />} />
            <Route path={StaticRoutes.Login} element={<Login />} />
            <Route
              path={StaticRoutes.Account}
              element={
                <RequireAuth>
                  <MyAccount />
                </RequireAuth>
              }
            >
              <Route
                path="update-profile"
                element={
                  <RequireAuth>
                    <AccountManagement />
                  </RequireAuth>
                }
              />
              <Route
                path="change-subscription"
                element={
                  <RequireAuth>
                    <AccountManagement />
                  </RequireAuth>
                }
              />
              <Route
                path="update-card"
                element={
                  <RequireAuth>
                    <AccountManagement />
                  </RequireAuth>
                }
              />
            </Route>
            <Route
              path={StaticRoutes.ConfirmEmail}
              element={<ConfirmEmail />}
            />
            {/*<Route path={StaticRoutes.Account} />*/}
            <Route
              path={StaticRoutes.PasswordResetSent}
              element={<PasswordResetSent />}
            />
          </Routes>
        </AccountContainer.Provider>
      </Auth.Provider>
    </QueryClientProvider>
  );
}

export default App;
